export default "__VITE_ASSET__697aa519__"